<template>
  <div class="container mt-5">
    <div class="card text-center floating-card">
      <h4 class="floating-content text-danger">Tabla de vacunas por niños/as</h4>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Nombres y Apellidos</th>
              <th>Número de Vacunas</th>
              <th>Ver</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="niño in niños" :key="niño.ninoId._id">
              <td>{{ niño.ninoId.nombres }} {{ niño.ninoId.apellidos }}</td>
              <td>{{ niño.vacunas.length }}</td>
              <td><a :href="'ninos/' + niño.ninoId._id" class="no-underline"><font-awesome-icon icon="eye" /></a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { BASE_URL } from '../store/config';

export default {
  data() {
    return {
      niños: [],
      errorLoadingNiños: null,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    loadNiños() {
      axios
        .get(`${BASE_URL}/api/vacuna/reporte`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        })
        .then(response => {
          // Agrupar vacunas por niño
          this.niños = response.data.reduce((acc, niño) => {
            const existingNiño = acc.find(item => item.ninoId._id === niño.ninoId._id);
            if (existingNiño) {
              existingNiño.vacunas.push(...niño.esquema);
            } else {
              acc.push({
                ninoId: niño.ninoId,
                vacunas: [...niño.esquema],
              });
            }
            return acc;
          }, []);
        })
        .catch(error => {
          this.errorLoadingNiños = 'Error al cargar niños. Por favor, inténtalo de nuevo.';
          console.error('Error al cargar niños:', error);
        });
    },
  },
  mounted() {
    this.loadNiños();
  },
};
</script>

<style>
.floating-card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  transition: box-shadow 0.3s ease-in-out;
}

.floating-content {
  transform: translate3d(0, -5px, 0);
  transition: transform 0.3s ease-in-out;
}

.grafico {
  margin-left: 80px;
}

.no-underline {
  text-decoration: none;
  color: inherit;
}
</style>
